export default "__VITE_ASSET__wPj3RHa0__"